<template>
  <div>
    <div v-for="(images, name) in previewImages" :key=name>
      <v-section-panel useBreak>
        <template v-slot:title>
          {{ images.name }}
        </template>
        <template v-slot:content>
          <template v-if="$store.getters['user/isFree']">
            <p v-if="images.name=='問題'" class="setting-alert">
              印刷した際に見開きにする必要があるページは、データをダウンロードした後で、空白ページを挿入するなどしてページ構成を調整してください。
            </p>
          </template>
          <template v-else>
            <p v-if="images.name=='問題' && selectedSubjectIsKokugo" class="setting-alert">
              著作権の都合上、文章付きで問題提供できない題材は、有料印刷を承ることができません。ご注意ください
            </p>
            <p v-if="images.name=='解答'" class="setting-alert">
              B4判で印刷されます。
            </p>
            <p v-if="images.name=='解答用紙'" class="setting-alert">
              B4判で印刷されます。
            </p>
          </template>
          <v-container fluid>
            <v-row>
              <v-col cols=3 v-for="(image, index) in images.data" :key=index>
                <!-- 画像表示 -->
                <v-card
                  class="mx-auto"
                  max-width="300"
                  elevation="10"
                  @click.stop="showPhotoSwipe(name, index)"
                >
                  <v-img
                    class="white--text align-end"
                    :src="image.src"
                  >
                  </v-img>
                </v-card>
              </v-col>
            </v-row>
            <template v-if="!$store.getters['user/isFree']">
              <p v-if="images.name=='解答用紙' && selectedSubjectIsSugaku && usedItems.length > 10 && images.data.length > 1" class="setting-alert">
                大問数が規定以上で、解答が小さすぎる恐れがあるので、解答用紙は２ページに分けました。
              </p>
              <p v-if="images.name=='解答'" class="setting-alert">
                「解答」は画面上では２色で表示されていますが、実際には１色で印刷して納品されます。
              </p>
            </template>
          </v-container>
        </template>
      </v-section-panel>
    </div>
    <v-photo-swipe
      :isOpen="isOpen"
      :items="selectedPreviewImage"
      :options="photoswipeOptions"
      @close="hidePhotoSwipe" />
  </div>
</template>

<script>
import VSectionPanel from '@/components/molecules/SectionPanel'
import VPhotoSwipe from '@/components/atoms/PhotoSwipe'
import { mapGetters } from 'vuex'

export default {
  components: {
    VSectionPanel,
    VPhotoSwipe,
  },

  props: {
    previewImages: {
      type: Object,
      default: () => {
        return {
          question: { name: '問題', data: [] },
          answerSheet: { name: '解答用紙', data: [] },
          answer: {name: '解答', data: [] },
        }
      }
    }
  },

  data: () => ({
    previewImageType: null,
    photoswipeOptions: {
      index: 0,
    },
    selectedPreviewImage: [],
    isOpen: false,
  }),

  computed: {
    ...mapGetters([
      'selectedSubjectIsSugaku',
      'selectedSubjectIsKokugo',
    ]),
    usedItems: {
      get() {
        return this.$store.state.sheet.usedItems
      },
      set(value) {
        this.$store.commit('sheet/setIsUpdate', {type: 'all', isUpdate: true})
        this.$store.commit('sheet/setUsedItems', {
          usedItems: value
        })
      }
    },
  },

  methods: {
    showPhotoSwipe(type, index) {
      this.isOpen = true
      this.selectedPreviewImage = this.previewImages[type].data
      this.$set(this.photoswipeOptions, 'index', index)
    },
    hidePhotoSwipe(){
      this.isOpen = false
    },
  }
}
</script>

<style lang="stylus" scoped>
.setting-alert
  color:#FF0000;
  font-weight:bold;
</style>
